import { Button, Col, Row } from 'antd';
import moment from 'moment';

import { BruhTimePicker } from '@atoms/bruhTimePicker';
import { faPlus, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type TProps = {
    title?: string;
    editing: boolean;
    breaks?: { start_break_time: string; end_break_time: string }[];
    onBreakDelete: (index: number) => void;
    tempBreak: { start_break_time?: Date; end_break_time?: Date };
    onTempBreakChange: (val: Date | null, target: 'start_break_time' | 'end_break_time') => void;
    tryAddBreak: (index: number, dates: moment.Moment[]) => void;
};

export const IntervalPicker = ({
    title = 'интервал',
    editing,
    breaks,
    onBreakDelete,
    tempBreak,
    onTempBreakChange,
    tryAddBreak,
}: TProps) => {
    return (
        <>
            {breaks?.map((value, index) => (
                <Row className="vpadded vcentered" key={'break-' + index}>
                    <Col>
                        <label className="hpadded">с</label>
                    </Col>
                    <Col>
                        <label className="hpadded">{value.start_break_time}</label>
                    </Col>
                    <Col>
                        <label className="hpadded">до</label>
                    </Col>
                    <Col>
                        <label className="hpadded">{value.end_break_time}</label>
                    </Col>
                    {editing && (
                        <Col>
                            <Button
                                danger
                                className="hmargined delete-btn"
                                icon={<FontAwesomeIcon icon={faXmark} />}
                                onClick={() => onBreakDelete(index)}
                                title={`Удалить ${title}`}
                            />
                        </Col>
                    )}
                </Row>
            ))}

            {editing && (
                <Row className="vpadded vcentered">
                    <Col>
                        <label className="hpadded">с</label>
                    </Col>
                    <Col>
                        <BruhTimePicker
                            closeOnSelect={true}
                            format="HH:mm"
                            onChange={(val, _) => onTempBreakChange(val, 'start_break_time')}
                            value={moment(tempBreak.start_break_time)}
                        />
                    </Col>
                    <Col>
                        <label className="hpadded">до</label>
                    </Col>
                    <Col>
                        <BruhTimePicker
                            closeOnSelect={true}
                            format="HH:mm"
                            onChange={(val, _) => onTempBreakChange(val, 'end_break_time')}
                            value={moment(tempBreak.end_break_time)}
                        />
                    </Col>
                    <Col>
                        <Button
                            disabled={
                                tempBreak.start_break_time == null ||
                                tempBreak.end_break_time == null
                            }
                            className="hmargined green-btn"
                            icon={<FontAwesomeIcon icon={faPlus} />}
                            onClick={() => {
                                tryAddBreak(null, [
                                    moment(tempBreak.start_break_time),
                                    moment(tempBreak.end_break_time),
                                ]);
                            }}
                            title={`Добавить ${title}`}
                        />
                    </Col>
                </Row>
            )}
        </>
    );
};
